import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';

@Component({
  selector: 'tt-travel-bills',
  templateUrl: './travel-bills.component.html',
  styleUrls: ['./travel-bills.component.css']
})
export class TravelBillsComponent implements OnInit {
    public argType: string;

    public argValue: string;

    webPageName;

    public setting?: Setting;

    public selectListLabours: LabourItem[] = [];

    public itemsListTravelBills: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.webPageName = this.stateService.getCurrentName();
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue && !!this.webPageName) {
            this.setting = (await this.datatask.Post(1251, {
                argtype: this.argType,
                argvalue: this.argValue,
                webpage_name: this.webPageName
            }))[0];
        }
    }

    private async loadLabours() {
        this.selectListLabours = await this.datatask.Post(1252);
    }

    private async loadTravelBills() {
        if (!this.setting) return;

        return this.itemsListTravelBills = await this.datatask.Post(1253, this.setting);
    }

    public async goToFunc(state: any) {
        switch (state) {
            case 'travelexpence':
                const response = (await this.datatask.Post(678, { counter_id: 'travelexpence_keyno' }))[0];

                this.stateService?.go('travelexpence', {
                    travelbill_no: '0',
                    travelexpence_keyno: response?.nextnumber
                });
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'labour_no':
                this.loadTravelBills();
                break;
            default:
                break;
        }
    }

    public onDateRangeChanged() {
        this.loadTravelBills();
    }

    private async init() {
        await this.loadSetting();
        this.loadLabours();
        this.loadTravelBills();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    labour_no: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    searchtext: string;
    show_setting: string;
}

interface LabourItem {
    labour_no: string;
    labour_name: string;
    orderby: number;
}
